import handlePageVisited from './handlers/handlePageVisited'
import handlePopupVideo from './handlers/handlePopupVideo'

export const UserEventsMap = {
    //TODO: AT-10144 - remove unused startup wizard popup event
    PLAY_VIDEO: 'Play Video',
    VIDEO_TIMELINE_UPDATED: 'Video Timeline Update',
    PAGE_VISIBLE: 'Page Visible',
    PAGE_HIDDEN: 'Page Hidden',
    POPUP_CLOSED: 'Popup Closed',
    POPUP_OPENED: 'Open Welcome Pop-Up',
    PAGE_VISITED: 'Page Visited',
    VIDEO_WATCHED: 'Video Watched',
    LICENSE_OBTAINED: 'License Obtained',
    ARTICLE_VISITED: 'Article Visited',
    TRIAL_READY: 'Trial Ready',
    BUDGET_TAB_OPEN: 'Budget Tab Open',
}

export const BudgetTabOpenEventEntityParams = {
    TASK: {Entity: "Task"},
    PROJECT: {Entity: "Project"},
    CUSTOMER: {Entity: "Customer"},
}

export const MonitoredEventsMap = {
    POPUP_OPENED: UserEventsMap.POPUP_OPENED,
    PAGE_VISITED: UserEventsMap.PAGE_VISITED,
    VIDEO_WATCHED: UserEventsMap.VIDEO_WATCHED,
    LICENSE_OBTAINED: UserEventsMap.LICENSE_OBTAINED,
}

export const EventsHandlersMap = {
    [UserEventsMap.PAGE_VISIBLE]: [handlePageVisited],
    [UserEventsMap.PAGE_HIDDEN]: [handlePageVisited, handlePopupVideo],
    [UserEventsMap.PLAY_VIDEO]: [handlePopupVideo],
    [UserEventsMap.VIDEO_TIMELINE_UPDATED]: [handlePopupVideo],
    [UserEventsMap.POPUP_CLOSED]: [handlePopupVideo]
}



// WEBPACK FOOTER //
// ./web/js/userEvents/UserEventsMap.js